module.exports = __webpack_public_path__ + "static/media/picInfoRegisterDDR.f9a32f2e.jpg";